const TOKEN_KEY = '@recorder/session_token';

type SessionTokenProps = {
  username: string;
  token: string;
  refresh: string;
  role: string;
  rendering: 'VIDEO' | 'AUDIO' | 'SIMULCAST';
  groups: string[];
};

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getLocalStorageData = () => {
  return JSON.parse(localStorage.getItem(TOKEN_KEY) as string);
};

export const createLocalStorageData = ({
  username,
  token,
  refresh,
  role,
  rendering,
  groups
}: SessionTokenProps) => {
  const tokenData = {
    username,
    token,
    refresh,
    role,
    rendering,
    groups
  };
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
};

export const deleteLocalStorageData = () => {
  localStorage.removeItem(TOKEN_KEY);
};
